import { render, staticRenderFns } from "./AfterCare.vue?vue&type=template&id=29adbafc&scoped=true"
import script from "./AfterCare.vue?vue&type=script&lang=js"
export * from "./AfterCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29adbafc",
  null
  
)

export default component.exports